// @ts-check
import {FileUpload} from '@/components/atoms'
import {useSortable} from '@dnd-kit/react/sortable'
import {Font, Icon} from 'pepsico-ds'
import {memo} from 'react'
import {useBrandImage} from './hooks/useBrandImage'
import {getCatalogItemName, getPositionLabel} from './utils/productCatalogUtils'

/**
 * @param {{brand: import('@/types/productCatalogTypes').ProductCategoryBrand, position: number, setBrands: import('react').Dispatch<import('react').SetStateAction<import('@/types/productCatalogTypes').ProductCategoryBrand[]>>}} props
 */
const BrandItemComponent = ({brand, position, setBrands}) => {
  const {ref, handleRef, isDragging} = useSortable({id: brand.id, index: position - 1})
  const {handleUpload, handleDelete, uploading, error, progress} = useBrandImage({brandId: brand.id, setBrands})
  const brandName = getCatalogItemName(brand)

  return (
    <div
      ref={ref}
      className={`flex min-h-40 w-[230px] min-w-[230px] flex-col items-center justify-between gap-2 rounded-lg border border-gray-400 p-2 ${isDragging ? 'opacity-50' : ''}`}
      style={{contentVisibility: 'auto', containIntrinsicSize: '230px 160px'}}
    >
      <Font size="xsmall" className="display-block w-full text-right">
        {getPositionLabel(position)}
      </Font>
      <div className="flex w-full items-center gap-2">
        <button ref={handleRef} className="cursor-grab touch-none">
          <Icon size="small" icon="drag_indicator" />
        </button>
        <FileUpload
          type="image"
          acceptedExtensions=".jpg,.png,.webp"
          className=""
          disabled={uploading}
          label=""
          imageUri={brand.imageUrl}
          onUpload={handleUpload}
          onUploadDelete={handleDelete}
          feedbackType={error ? 'error' : 'info'}
          helperText={error || ''}
          description="Drag and drop your file here (only .jpg,.png,.webp)"
          progressPercentage={progress}
          value={[]}
        />
      </div>
      <Font size="xsmall" variant="bold" className="uppercase">
        {brandName}
      </Font>
    </div>
  )
}

export const BrandItem = memo(BrandItemComponent)
